import * as t from 'io-ts';
import {isObject} from 'lodash';
import {Observable} from 'rxjs';

import {ApiType} from '../../../libs/shared/core/src/models/api/commonApiTypes';

/*
 * Generic resource caching on disk.
 */

export interface OfflineResourceCache<ID extends number | string, RESOURCE extends object> {
  apiType: ApiType<t.Type<RESOURCE, unknown>>;
  readAsync(id: ID): Promise<RESOURCE | undefined>;
  readAllAsync(): Promise<ReadonlyArray<RESOURCE>>;
  readAllIdsAsync(): Promise<ReadonlyArray<ID>>;
  readStatsAsync(): Promise<OfflineResourceCacheStats>;
  readIfLatestAsync(id: ID, getLatestTimestamp: () => number | undefined): Promise<RESOURCE | undefined>;
  addAsync(id: ID, resource: RESOURCE, timestamp?: number): Promise<void>;
  canAddTimestampAsync(timestamp: number): Promise<boolean>;
  addedIds$: Observable<ID>;
  removeAsync(id: ID): Promise<void>;
  getCacheResponseInfo(id: ID, resource: RESOURCE): CacheResponseInfo;
}

export interface OfflineResourceCacheStats {
  minTimestamp: number | undefined;
  maxTimestamp: number | undefined;
  count: number;
}

export interface CacheResponseInfo {
  contentUpdatedAt: number;
  fetchedAt: number;
}

export interface ResourceRecord {
  resource: unknown;
  timestamp: number;
}

export function isCacheResponseInfo(x: unknown): x is CacheResponseInfo {
  return (
    isObject(x) &&
    (x as CacheResponseInfo).contentUpdatedAt !== undefined &&
    (x as CacheResponseInfo).fetchedAt !== undefined
  );
}
